var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowTypeElt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6896_46038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41 0L0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6896_46038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82016 0L7.41016 1.41L11.9902 6L7.41016 10.59L8.82016 12L14.8202 6L8.82016 0Z",
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6896_46038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2303 0L14.8203 1.41L19.4003 6L14.8203 10.59L16.2303 12L22.2303 6L16.2303 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6896_46038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.41,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6896_46038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.41,
    height: 12,
    fill: "white",
    transform: "translate(7.41016)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6896_46038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.41,
    height: 12,
    fill: "white",
    transform: "translate(14.8203)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowTypeElt);
export default __webpack_public_path__ + "static/media/flowTypeELT.296a7728a86d8f2d3121cb5f9de493ba.svg";
export { ForwardRef as ReactComponent };